import { selectContractPackagesState } from '../index';
import { createSelector } from '@ngrx/store';
import { ContractPackagesState } from '../reducers/contract-packages.reducer';

export const selectContractPackages = createSelector(
  selectContractPackagesState,
  (state: ContractPackagesState) => state && state.contractPackages
);
export const selectContractPackagesLoading = createSelector(
  selectContractPackagesState,
  (state: ContractPackagesState) => state && state.loading
);
export const selectContractPackagesError = createSelector(
  selectContractPackagesState,
  (state: ContractPackagesState) => state && state.error
);
